import { Link } from "@certn/cascadia-react";
import { getPrivacyPolicyUrl, getServiceAgreementUrl } from "@certn/utils";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { LanguageLink } from "./LanguageLink";

export function AppFooterLinks() {
  const { t, i18n } = useTranslation();

  const privacyPolicyUrl = getPrivacyPolicyUrl(i18n.language);
  const serviceAgreementUrl = getServiceAgreementUrl(i18n.language);
  return (
    <div className={styles.footer}>
      <LanguageLink />
      <Link
        textStyle="form/body-secondary-link"
        textColor="text-weak"
        testID="privacy-policy-link"
        href={privacyPolicyUrl}
        target="_blank"
      >
        {t("Privacy policy")}
      </Link>
      <Link
        textStyle="form/body-secondary-link"
        textColor="text-weak"
        testID="service-agreement-link"
        href={serviceAgreementUrl}
        target="_blank"
      >
        {t("Service Agreement")}
      </Link>
    </div>
  );
}

const styles = {
  footer: css({
    display: "flex",
    width: "100%",
    justifyContent: "flex-end",
    alignItems: "center",
    paddingRight: "var(--space-2)",
    columnGap: "var(--space-5)",
  }),
};
